@if (!longText) {
  <input
    #input
    [type]="controlType"
    class="form-control"
    [class.is-invalid]="hasError"
    (blur)="onBlur()"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [readOnly]="readOnly"
    [maxlength]="maxlength"
    (ngModelChange)="onChange()"
    />
}
@if (longText) {
  <textarea
    #input
    class="form-control"
    [class.is-invalid]="hasError"
    (blur)="onBlur()"
    [disabled]="disabled"
    [readOnly]="readOnly"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="onChange()"
    [rows]="rows"
    [maxlength]="maxlength"
  ></textarea>
}
